import AppProvider from "./contexts/app/AppProvider";

function App() {
  return <AppProvider />;
}

export default App;
